import { GlButton, GlDisclosureDropdownItem, GlFormGroup, GlFormInputGroup, GlModal, GlModalDirective, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SimpleCopyButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/simple_copy_button.vue?vue3';
import { getHTTPProtocol } from '~/lib/utils/url_utility';
import { __, sprintf } from '~/locale';
export default {
    name: 'CloneWikiModal',
    i18n: {
        steps: {
            step1: __('Clone repository')
        },
        cloneWithSsh: __('Clone with SSH')
    },
    components: {
        GlButton,
        GlDisclosureDropdownItem,
        GlFormGroup,
        GlFormInputGroup,
        GlModal,
        SimpleCopyButton
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    inject: {
        cloneSshUrl: {
            default: null
        },
        cloneHttpUrl: {
            default: null
        }
    },
    props: {
        showAsDropdownItem: {
            type: Boolean,
            required: false,
            default: false
        },
        modalId: {
            type: String,
            required: false,
            default: 'clone-wiki-modal'
        }
    },
    computed: {
        httpLabel () {
            const protocol = this.cloneHttpUrl ? getHTTPProtocol(this.cloneHttpUrl)?.toUpperCase() : '';
            return sprintf(__('Clone with %{protocol}'), {
                protocol
            });
        },
        cloneSshUrlDisplay () {
            return `git clone ${this.cloneSshUrl}`; // eslint-disable-line @gitlab/require-i18n-strings
        },
        cloneHttpUrlDisplay () {
            return `git clone ${this.cloneHttpUrl}`; // eslint-disable-line @gitlab/require-i18n-strings
        },
        listItem () {
            return {
                text: __('Clone repository'),
                extraAttrs: {
                    'data-testid': 'page-clone-button'
                }
            };
        }
    },
    modal: {
        modalId: 'clone-wiki-modal'
    }
};
